import { render } from "./CreditoFattura.vue?vue&type=template&id=57adb34a&scoped=true"
import script from "./CreditoFattura.vue?vue&type=script&lang=js"
export * from "./CreditoFattura.vue?vue&type=script&lang=js"

import "./CreditoFattura.vue?vue&type=style&index=0&id=57adb34a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ma-dg\\Desktop\\wa\\ask_wizard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57adb34a"]])

export default __exports__